import styled from 'styled-components';
import { RoundedCard } from '../../style';

export const DeliveryItemContainer = styled(RoundedCard)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 16px;
    align-items: center;
`;